import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { RadioBtnGroup } from '@tmapy/style-guide';
export class SizeOption extends React.PureComponent {
    render() {
        return (_jsx(RadioBtnGroup, { value: this.props.value, items: this.props.items, onChange: this.props.onChange }));
    }
}
//# sourceMappingURL=component.js.map